import * as Yup from "yup";
const ngoSignUpValidationSchema = Yup.object({
  name: Yup.string().required("This field is required"),
  year_founded: Yup.string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(4, "Must be 4 digits")
    .max(4, "Must be 4 digits")
    .required("This field is Required"),
  category: Yup.string().required("This field is required"),
  yearly_projects: Yup.bool("Select a valid option").required(
    "This field is required"
  ),
  yearly_report: Yup.bool("Select a valid option").required(
    "This field is required"
  ),
  website: Yup.string()
    .matches(
      /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      "Please enter a valid URL"
    )
    .required("This field is required"),
  address: Yup.string().required("This field is required"),
});

export { ngoSignUpValidationSchema };
